import React from 'react';
import { A11y, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import { PaginationOptions } from 'swiper/types';

import { ImageWithTextRightLeft } from '../ImageWithTextRightLeft/ImageWithTextRightLeft';

import { ArticleSetOfTextWithHeader } from '../ArticleSetOfTextWithHeader';

import { PageComponent } from '../PageComponent/PageComponent';

import { RichText } from '../RichText/RichText';

import { CarouselProps } from './Carousel.types';

import CarouselSlide from './CarouselSlide';

import 'swiper/css';
import 'swiper/css/pagination';
import * as classes from './Carousel.module.scss';

const Carousel: React.FC<CarouselProps> = ({ elements, layout, title }) => {
    const pagination: PaginationOptions = {
        clickable: true,
        bulletClass: layout === 'No background' ? classes.customBulletBrighter : classes.customBullet,
        bulletActiveClass: layout === 'No background' ? classes.customBulletActiveBrand : classes.customBulletActive,
        horizontalClass: classes.customBulletContainer,
    };
    const isOnlyOneElement = elements.length === 1;
    return (
        <>
            {title && (
                <div className={classes.titleContainer}>
                    <RichText content={title} textSize="sectionTitle" />
                </div>
            )}

            <Swiper
                autoHeight={false}
                pagination={pagination}
                modules={[Pagination, A11y]}
                className={layout === 'Background image' ? classes.withBackground : classes.withoutBackground}
            >
                {elements.map((element, index) => {
                    switch (element.content?.__typename) {
                        case 'ContentfulSetOfTextWithHeaderTextWithHeader':
                            return (
                                <SwiperSlide key={index}>
                                    <CarouselSlide
                                        title={element.content.richTitle}
                                        singleColumnContent={element.content.singleColumnContent}
                                        icons={element.content.icons}
                                        backgroundImage={element.image}
                                        linkMore={element.content.linkMore}
                                        isOnlyOneElement={isOnlyOneElement}
                                    />
                                </SwiperSlide>
                            );
                        case 'ContentfulGenericSetOfTextWithHeader':
                            return (
                                <SwiperSlide key={index}>
                                    <PageComponent>
                                        <ArticleSetOfTextWithHeader
                                            richTitle={element.content.richTitle}
                                            texts={element.content.texts}
                                            darkTheme={element.content.darkTheme}
                                            bulletType={element.content.bulletType}
                                            showLine={element.content.showLine}
                                            elements={element.content.elements}
                                            layout={element.content.layout}
                                            maximumNumberOfColumns={element.content.maximumNumberOfColumns}
                                        />
                                    </PageComponent>
                                </SwiperSlide>
                            );
                        case 'ContentfulGenericTextWithImage':
                            return (
                                <SwiperSlide key={index}>
                                    <div className={classes.textWithImageContainer}>
                                        <PageComponent>
                                            <ImageWithTextRightLeft
                                                layout={element.content.layout}
                                                elements={element.content.elements}
                                            />
                                        </PageComponent>
                                    </div>
                                </SwiperSlide>
                            );
                    }
                })}
            </Swiper>
        </>
    );
};

export default Carousel;
